import CloseIcon from '@mui/icons-material/Close';
import { ReactComponent as PushPin } from 'assets/img/push_pin.svg';
import classNames from 'classnames';

import ELEMENT from 'common/element';
import Toolbar from 'components/common/Toolbar/Toolbar';
import './LogDetails.scss';

export type LogDetailsHeaderProps = {
  onClose:         () => void;
  onTogglePinned?: () => void;
  isPinned?:       boolean,
  title?:          string,
};

/**
 * This component provides a header with a title and buttons to pin or close the component.
 *
 * @prop onClose        function to close the component
 * @prop onTogglePinned function to handle a click of the Pin button
 * @prop isPinned       true if the view has been pinned
 * @prop title          text for the header
 */
function LogDetailsHeader({
  onClose,
  onTogglePinned,
  isPinned,
  title,
}: LogDetailsHeaderProps): JSX.Element {

  const leftItems = [<div className="Dialog__Title">{title || 'Inspect Log Line'}</div>];
  const rightItems = [
    <div
      onClick={onTogglePinned}
      title={isPinned ? 'Unpin Log Details' : 'Pin Log Details'}
      className={classNames({ LogDetails__UnPin: isPinned })}
    >
      <PushPin className="LogDetails__Pin" />
    </div>,
    <div className="Dialog__Close" data-test-id={ELEMENT.inspectFieldsDrawerClose}>
      <CloseIcon onClick={onClose} />
    </div>,
  ];

  return (
    <Toolbar
      className="LogDetails__Header"
      leftItems={leftItems}
      rightItems={rightItems}
    />
  );

}

export default LogDetailsHeader;
